import { FragmentRESTSerializer as RESTSerializer } from 'ember-data-model-fragments/serializer';

export default class Base extends RESTSerializer {
  payloadKeyFromModelName(modelName) {
    return super.payloadKeyFromModelName(modelName).replace(/^surveys\//, '');
  }

  modelNameFromPayloadKey(key) {
    return super.modelNameFromPayloadKey('surveys/' + key);
  }
}
